export default function GetExpanderClasses(isExpanded: boolean): string {
    if (isExpanded) {
        return "v-icon notranslate v-data-table__expand-icon v-icon--link theme--light v-data-table__expand-icon--active";
    }
    return "v-icon notranslate v-data-table__expand-icon v-icon--link theme--light";
}